import { services } from '@lifetools/shared-services';

/**
 * Turns off realtime data subscriptions for this instance of the application.
 */
export default function disableRealtimeData() {
  // Setting this to `undefined` causes all existing data subscriptions to be unsubscribed from
  services.data.listener = undefined;
}
